import { createStyles } from 'core/utilities/theme';
import { HOVER_TOOLTIP_Z_INDEX } from 'sequenceAnalyser/components/Sequences/SequencesStyling/SequencesStyling.style';

export default createStyles({
  tooltipTarget: {
    position: 'absolute',
    background: 'white',
  },
  popper: {
    zIndex: HOVER_TOOLTIP_Z_INDEX,
  },
});
